import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
    Button,
    TextField,
    Paper, Modal,
    Typography, Box,
    AppBar,
    Toolbar
} from "@mui/material";
import LoadingBar from "react-top-loading-bar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditVehicleType = () => {
    const { vehicleTypeId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [vehicleType, setVehicleType] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [loadingBarProgress, setLoadingBarProgress] = useState(0);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    useEffect(() => {
        if (location.state?.vehicleType) {
            setVehicleType(location.state.vehicleType.vehicleType || "");
            setIsLoading(false);
        } else {
            fetchVehicleTypeById();
        }
    }, [vehicleTypeId]);

   const fetchVehicleTypeById = async () => {
    try {
        setLoadingBarProgress(30);
        const apiUrl = process.env.REACT_APP_BASE_URL;

        const res = await fetch(`${apiUrl}/Transportation/VehicleType`, {
            method: "PUT", // ✅ This is correct based on your previous working code
            headers: {
                "Content-Type": "application/json",
                Authorization: sessionStorage.getItem("token"),
            },
            body: JSON.stringify({}),
        });

        if (!res.ok) throw new Error("Failed to fetch vehicle types");

        const allTypes = await res.json();
        const match = allTypes.find(v => v.vehicleTypeId === parseInt(vehicleTypeId));

        if (!match) {
            setError("Vehicle type not found.");
        } else {
            setVehicleType(match.vehicleType || "");
        }
    } catch (err) {
        console.error("Fetch error:", err);
        setError("Error fetching vehicle type.");
    } finally {
        setIsLoading(false);
        setLoadingBarProgress(100);
    }
};


const handleSubmit = async (e) => {
    e.preventDefault();

    if (!vehicleType.trim()) {
        // alert("Please enter the vehicle type.");
         setSnackbarMessage("Please enter the vehicle type.");
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
        return;
    }

    try {
        setLoadingBarProgress(30);
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const encodedType = encodeURIComponent(vehicleType.trim());

        const res = await fetch(
            `${apiUrl}/Transportation/VehicleType/${vehicleTypeId}?vehicleType=${encodedType}`,
            {
                method: "PUT",
                headers: {
                    Authorization: sessionStorage.getItem("token"),
                },
            }
        );

        if (res.ok) {
           setShowSuccessModal(true);

        } else {
            throw new Error("Failed to update");
        }
    } catch (err) {
        console.error("Update error:", err);
        setSnackbarMessage("Error updating vehicle type.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
    } finally {
        setLoadingBarProgress(100);
    }
};



    return (
        <div className="container mt-4">
            <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
             <Box display="flex" flexDirection="column" alignItems="center">
           <Box
          sx={{
            backgroundColor: '#0B1F40', // dark navy blue
            padding: '12px 24px',
            boxShadow: 3,
            borderRadius: '4px 4px 0 0',
            margin: '2px auto',
           width: "900px",
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', textAlign:'center', fontWeight: 'bold' }}>
        Edit Vehicle Type
      </Typography> </Box>


            <Paper elevation={3} style={{ padding: 16, marginTop: 6, width: "900px", }}>
                {isLoading ? (
                    <Typography>Loading...</Typography>
                ) : error ? (
                    <Typography color="error">{error}</Typography>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <Typography variant="h6" gutterBottom>
                            Update Vehicle Type
                        </Typography>

                        <TextField
                            label="Vehicle Type"
                            value={vehicleType}
                            onChange={(e) => setVehicleType(e.target.value)}
                            fullWidth
                            margin="normal"
                            required
                        />

                        <div style={{ marginTop: 16 }}>
                            <Button
                                type="submit"
                                variant="contained"
                                style={{ backgroundColor: "#0B1F3D", marginRight: 8 }}
                            >
                                Save Changes
                            </Button>
                            <Button variant="outlined" color="error" onClick={() => navigate(-1)}>
                                Cancel
                            </Button>
                        </div>
                    </form>
                )}
            </Paper></Box>

           <Modal
  open={showSuccessModal}
  onClose={() => setShowSuccessModal(false)}
  aria-labelledby="success-modal-title"
  aria-describedby="success-modal-description"
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      overflow: 'hidden',
    }}
  >
    {/* Header */}
    <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
      <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
        Vehicle Updated ✅
      </Typography>
    </Box>

    {/* Content */}
    <Box sx={{ padding: '20px' }}>
      <Typography id="success-modal-description" sx={{ mb: 2 }}>
        The Vehicle Type has been updated successfully.
      </Typography>

      {/* Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          onClick={() => {
            setShowSuccessModal(false);
            navigate(-1); // go back after closing modal
          }}
          variant="contained"
          color="primary"
        >
          OK
        </Button>
      </Box>
    </Box>
  </Box>
</Modal>
<Snackbar
  open={snackbarOpen}
  autoHideDuration={4000}
  onClose={() => setSnackbarOpen(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>



        </div>
    );
};

export default EditVehicleType;
